import React from 'react';
import { TArticle } from '../../../models/common';
import styles from './article-content-sidebar.module.scss';
import { WStack, WTypography } from '../../wrappers/wrapper';

type ArticleContentSidebarProps = {
  article: TArticle;
  isDocumentation?: boolean;
}

const ArticleContentSidebar: React.FC<ArticleContentSidebarProps> = ({ article, isDocumentation }) => {
  if (!isDocumentation || !article.content_array || article.content_array.length === 0) {
    return null;
  }

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className={styles.sidebar}>
      <WTypography variant="h6" className={styles.title}>
        {article.title}
      </WTypography>
      <WStack className={styles.contentTree}>
        {article.content_array.map((section, index) => (
          <div key={index} className={styles.section}>
            <div 
              className={styles.sectionTitle}
              onClick={() => scrollToSection(`section-${index}`)}
            >
              {section.title}
            </div>
            {section.subcontent && section.subcontent.length > 0 && (
              <div className={styles.subsections}>
                {section.subcontent.map((sub, subIndex) => (
                  <div 
                    key={subIndex}
                    className={styles.subsectionTitle}
                    onClick={() => scrollToSection(`subsection-${index}-${subIndex}`)}
                  >
                    {sub.title}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </WStack>
    </div>
  );
};

export default ArticleContentSidebar; 